import { getThisYear } from "./customChart";

//공통 js
export default{

    // 모바일 공통함수 : 윤태영 (010-0000-0000 포맷처리)  
    phoneFormat(mobile){
        var mobileValue =  mobile.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/);
        mobileValue  = !mobileValue[2] ? mobileValue[1] : '' + mobileValue[1] + '-' + mobileValue[2] + (mobileValue[3] ? '-' + mobileValue[3] : '');
        return mobileValue
    },
    // 전화번호/ 유선 공통함수
    teleFormat02(mobile){
        var mobileValue =  mobile.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
        if(mobile.length > 11) mobileValue = mobile.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,4})/);
        mobileValue  = !mobileValue[2] ? mobileValue[1] : '' + mobileValue[1] + '-' + mobileValue[2] + (mobileValue[3] ? '-' + mobileValue[3] : '');
        return mobileValue
    },
    teleFormat(mobile){
        var mobileValue =  mobile.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if(mobile.length > 12) mobileValue = mobile.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/);
        mobileValue  = !mobileValue[2] ? mobileValue[1] : '' + mobileValue[1] + '-' + mobileValue[2] + (mobileValue[3] ? '-' + mobileValue[3] : '');
        return mobileValue
    },
    //휴대폰, 유선전화 구분 함수(M:핸드폰,P:유선,I:인터넷,N:알수없음)
    checkPhoneType(mobile){
        let input = mobile.replace(/\D/g, ''); // 숫자만 남기기
        let mobileType = '';
        const mobileRegex = /^01[0-9]\d{0,8}$/; // 휴대폰 패턴 (010, 011, ...)
        const landlineRegex = /^0[2-9]\d{0,7}$/; // 유선전화 패턴 (02, 031, 051 등)
        const internetPhoneRegex = /^0(70|50\d)\d{0,7}$/; // 인터넷 전화 (070, 0505)

        if (mobileRegex.test(input)) {
            mobileType ='M'
        } else if (landlineRegex.test(input)) {
            mobileType = 'P'
        } else if (internetPhoneRegex.test(input)) {
            mobileType = 'I'
        } else {
            mobileType = 'N'
        }
        return mobileType;

    },
    // 사업자번호 포맷처리 (000-00-00000)
    bizNoFormat(no){
        no = no.replace(/[^0-9]/g, '');
        let tmp = '';
        if( no.length < 4){
          return no;
        }else if(no.length < 6){
          tmp += no.substr(0, 3);
          tmp += '-';
          tmp += no.substr(3);
          return tmp;
        }else if(no.length < 11){
          tmp += no.substr(0, 3);
          tmp += '-';
          tmp += no.substr(3, 2);
          tmp += '-';
          tmp += no.substr(5);
          return tmp;
       }  
        return no;
    },    
    //숫자구성인지 체크
    checkNumber(data){
        const regex = /^[0-9]*$/ // 숫자만 체크해서 안나옴
        return regex.test(data)
    },
    checkFloat(data){
        const regex = /^[0-9]+\.?[0-9]+$/
        return regex.test(data)
    },
    //숫자만 입력이 가능
    checkOnlyNumber(data){  // /^[0-9]+$/; 
        let regex =  /[^0-9]/g // 숫자만 체크

        return data.replaceAll(regex,'')

        
        // let regexTest = regex.test(data);

        // if(regexTest){
        //     return data;
        // }else {
        //     return data.replace(regex,'');
        // }

    },
    //특수문자 지우기 윤태영
    checkSpecChar(data){
        let regex = /[\{\}\[\]\?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
        return data.replaceAll(regex,'')
    },
    checkSpecChar2(data){
        let regex =  /[\{\}\[\]\?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
        let regexTest = regex.test(data)

        if(regexTest){
            return data;
        }else {
            return ""
        }
    },
   
    //이메일 형식 체크
    checkEmail(data){
        let regex =  /^[a-zA-Z0-9._-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/i;
        let regexTest = regex.test(data)
        return regexTest
    },
    validateEmail(data){
        let regex =  /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
        return regex.test(data)
    },
    //휴대폰 형식 체크 
    checkPhone(data){
        let regex =  /01[016789]-[^0][0-9]{2,3}-[0-9]{3,4}/
        return regex.test(data);
    },
    //전화번호(유선) 형식 체크
    checkTelNumber(data){
        let regex =  /^(02|0[3-6]{1}[1-5]{1})-?([0-9]{3,4})-?[0-9]{4}$/
        return regex.test(data);
    },
    //사업자 번호 형식 체크
    checkBizno(data){
        let regex = /^\d{3}-\d{2}-\d{5}$/
        return regex.test(data);
    },
    //3자리 수 , 적용 함수 
    checkNumberComma(data){
        if(data){
            data = data.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        return data == 'NaN'? 0 :data;
    },
    //date 일자 형식 체크
    checkDateForm(data){
        let regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
        return regex.test(data)
    },
    //그리드 형식 틀릴 시 class 변환
    getGridClass(dataType,data){
        let classNm = ''

        switch (dataType) {
            //1.숫자형 체크
            case 'number':
                if(!this.checkNumber(data)){
                    classNm = 'redCell'
                }
              break;

             //2.특수문자 제외 문자열 체크
            case 'string':
                if(!this.checkSpecChar(data)){   //FALSE
                    classNm = 'redCell'
                    ////alert("특수문자가 있습니다.");
                }
              break;

            //3.휴대폰 번호 형식 체크
            case 'phone':
                if(this.checkPhone(data)){
                    classNm = 'redCell'
                }
              break;

             //4.이메일 형식 체크
            case 'email':
                if(this.checkEmail(data)){
                    classNm = 'redCell'
                }
              break;

            //5.날짜 형식 체크
            case 'date':
              statement2;
              break;
            
            default:
              '';
        }
        
          return classNm
    },
    //특정날짜을 문자열 형식으로 변환한다.(yyyy-mm-dd)
    dateFormat(date, separator = '-') {
        var yyyy = date.getFullYear();
        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [yyyy
                , separator
                , (mm > 9 ? '' : '0') + mm
                , separator
                , (dd > 9 ? '' : '0') + dd
        ].join('');
    },
    //특정날짜에 월을 가감한 날짜를 반환한다.
    addMonth(date, months) {
        let rDate = new Date(date);

        // 1일로 설정하고, 월 가감 후, 아래에서 현재일자를 재설정
        rDate.setDate(1);
        rDate.setMonth(rDate.getMonth() + months);

        // 현재일자를 재설정
        const currDays = date.getDate();
        const lastDays = new Date(rDate.getFullYear(), rDate.getMonth() + 1, 0).getDate(); // 해당 월의 마지막 일자 구하기

        rDate.setDate(Math.min(currDays, lastDays));
        
        return rDate;
    },
    //빈 값 여부
    isEmpty(value) {
        if(Array.isArray(value)) {
            return !value.length;
        }
        
        return !Object.keys(value).length;
    },
    //빈 값 여부
    isNotEmpty(value) {
        return !this.isEmpty(value);
    },

    // 사업자번호 유효성 체크
    checkVaildBizNum(number) {
        let numberMap = number.replace(/-/gi, '').split('').map(function (d) {
          return parseInt(d, 10);
        });
  
        if (numberMap.length === 10) {
          let keyList = [1, 3, 7, 1, 3, 7, 1, 3, 5];
          let chk    = 0;
  
          keyList.forEach(function (d, i) {
            chk += d * numberMap[i];
          });
  
          chk += parseInt((keyList[8] * numberMap[8]) / 10, 10);
          return Math.floor(numberMap[9]) === ((10 - (chk % 10)) % 10);
        }
  
        return false;
    },

    //상품 상위 코드 찾기
    findUperCode(codeId,list){
        if(!list || list?.length === 0) return

        let [ parentKey ] = Array.from(new Set(list.map(item => Object.keys(item).find(key => key.includes('up_')))))
        let key = parentKey?.split('up_').join('') || null
        if(!key) return
        let codeFam = []
        this.recursiveFindCode(codeId,list,codeFam,parentKey,key)
        
        return codeFam.reverse() || []
    },

    recursiveFindCode(codeId,list,codeFam,parentKey,key){
        for(let code of list){
            if(code[key] == codeId){
                // let classNm = 'class_nm' + code.level
                codeFam.push(code)
                if(code[parentKey] != ''){
                    this.recursiveFindCode(code[parentKey],list,codeFam,parentKey,key)
                }
            }
        }
    },
    //비밀번호 정책 정규식(영문 대/소문자,숫자,특수문자 포함 및 8자 이상)
    checkPwdForm(pwd){
        const regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,}$/
        return regex.test(pwd)
    },

    /**
     * 메뉴 접근 체크
     * @param {string} menuId 메뉴 ID
     * @returns
     */
    checkAccessAuth(menuId){
        const userStore = JSON.parse(sessionStorage.getItem('user'))
        if(!userStore.user || !menuId) return false

        return userStore.user.mnUrl.includes(menuId)
    },

    /**
     * 당해 년도 가져오기
     * @returns {string}
     */
    getThisYear() {
        return new Date().getFullYear()
    },

    /**
     * 날짜형식 '-'넣기
     * @returns {string}
     */
    formatDateHyphen(dateStr){
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);

        return `${year}-${month}-${day}`

    }
}